import React from 'react';
import { Box } from '@mui/material';

function EnvironmentBanner() {
    const hostname = window.location.hostname;

    if (hostname.includes('web-np.dealer')) {
        return (
            <Box sx={{ backgroundColor: 'orange', color: 'black', textAlign: 'center', px: 3, py: 1 }}>
                <h3 style={{ margin: '0 0 4px 0' }}>NONPROD</h3>
            </Box>
        );
    }

    if (hostname.includes('web.dealer')) {
        return (
            <Box sx={{ backgroundColor: 'red', color: 'white', textAlign: 'center', px: 3, py: 1 }}>
                <h3 style={{ margin: '0 0 4px 0' }}>PRODUCTION</h3>
                <p style={{ margin: 0 }}>Changes made here will impact a publisher's ability to publish SCM content to live Dealer.com websites.</p>
            </Box>
        );
    }

    if (hostname.includes('localhost')) {
        return (
            <Box sx={{ backgroundColor: 'orange', color: 'black', textAlign: 'center', px: 3, py: 1 }}>
                <h3 style={{ margin: '0 0 4px 0' }}>LOCAL</h3>
            </Box>
        );
    }

    return null;
}

export default EnvironmentBanner;
